import * as React from 'react';
import { useSelector } from 'react-redux';
import { ETopBetsStatus } from '../../../../redux/reducers';
import { selectFormattedBetLeaders, selectTopBetsStatus } from '../../../../selectors/topBets';
import { BetLeadersList } from './BetLeadersList';
import { LeadersSkeleton } from './components/LeadersSkeleton';

export const BetLeadersListContainer = () => {
  const leaders = useSelector(selectFormattedBetLeaders);
  const status = useSelector(selectTopBetsStatus);

  if (status !== ETopBetsStatus.success && leaders.length === 0) {
    return <LeadersSkeleton />;
  }

  return <BetLeadersList leaders={leaders} />;
};
